import { projectConstants } from "../constant/project.constants";

export const initialState = {
    project: {
        id: '',
        projectCode: '',
        projectName: '',
        aliasName: '',
        projectTypeId: '',
        active: '',
        defaultProject: ''
    },
    dataProject: [
    ],
    errorCode: '',
    successCode: '',
    isLoading: false
};
const projectReducer = (state = initialState, action) => {
    switch (action.type) {
        case projectConstants.GET_SUCCESS:
            return {
                ...state,
                dataProject: action.projectList,
                isLoading: false
            };
        case projectConstants.ADD_SUCCESS:
            return {
                ...state,
                successCode: action.code,
                isLoading: true
            };
        case projectConstants.ADD_FAILURE:
            return {
                ...state,
                errorCode: action.error,
                isLoading: false
            };
        case projectConstants.DELETE_SUCCESS:  
            return {
                ...state,
                successCode: action.code,
                isLoading: true
            };    
        case projectConstants.DELETE_FAILURE:
            return {
                ...state,
                errorCode: action.error,
                isLoading: false
            };  
        case projectConstants.UPDATE_SUCCESS:  
            return {
                ...state,
                successCode: action.code,
                isLoading: true
            };    
        case projectConstants.UPDATE_FAILURE:
            return {
                ...state,
                errorCode: action.error,
                isLoading: false
            };  
        default:
            return state;
    }
};

export default projectReducer;
